import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

// common
import useGeneralHook from 'common/hook/useGeneralHook';
import useService from 'common/hook/useService';

// screen
import type { UpdateConfirmationCodeBody } from 'modules/confirmation-code/types';

interface MutatingProps {
  id: string;
  body: UpdateConfirmationCodeBody;
}

/** Sửa Mã xác nhận (hạn / trạng thái / hạn mức lượt). KHÔNG đổi chuỗi mã. */
const useUpdateConfirmationCode = () => {
  const service = useService();
  const { enqueueSnackbar } = useGeneralHook();

  const mutation = useMutation({
    mutationFn: async ({ id, body }: MutatingProps) => {
      if (!service) return null;
      try {
        const res = await service.ConfirmationCodeController_update({ params: { id }, body });
        enqueueSnackbar({ message: 'Cập nhật mã xác nhận thành công.', variant: 'success' });
        return res?.data ?? null;
      } catch (error) {
        const data = (error as AxiosError<{ code?: string; Code?: string }>)?.response?.data;
        enqueueSnackbar({
          message: `Cập nhật thất bại${data?.code || data?.Code ? ` (${data?.code || data?.Code})` : ''}.`,
          variant: 'error',
        });
        throw error;
      }
    },
  });

  return { mutateAsync: mutation.mutateAsync, isPending: mutation.isPending };
};

export default useUpdateConfirmationCode;
